/**
 * The date range selector for incoming shipments
 */

import React from "react";
import ButtonGroup, { ButtonOption } from "@amzn/meridian/button-group";
import useIncomingShipmentsFiltersNew from "../../hooks/use-incoming-shipments-filters-new";
import dateRangesNew, { getDateRangeById1 } from "../../data/date-ranges-new";

const IncomingShipmentsDateFilterNew = () => {
  const { filters, dispatch } = useIncomingShipmentsFiltersNew();

  const onChangeFilter = (value) => {
    if (!value || value.length === 0) {
      dispatch({ type: "REMOVE_FILTER", filter: "dateRangeNew" });
    } else {
      dispatch({
        type: "UPDATE_FILTER",
        filter: "dateRangeNew",
        value,
        tagLabel: value.map(
          dateRange => `Date: ${getDateRangeById1(dateRange).label}`
        ),
      });
    }
  };

  return (
    <ButtonGroup
      value={filters.get("dateRangeNew")?.value || []}
      onChange={onChangeFilter}
      id="date-range-select"
      type="primary"
    >
      {dateRangesNew.map(({ id, label }) => (
        <ButtonOption key={id} value={id}>
          {label}
        </ButtonOption>
      ))}
    </ButtonGroup>
  );
};

export default IncomingShipmentsDateFilterNew;
